/** Wat Sarah nog moet aanleveren vóór livegang. Staat ingeklapt onderaan het overzicht; leeg = weg. */
export const launchList: { text: string; to: string | null }[] = [
  { text: 'Inhoud (ml) en gebruiksduur per product invullen', to: '/be/producten' },
  { text: 'Gebruiksadvies per product nalopen', to: '/be/producten' },
  { text: 'Echte Spotify-link van de podcast', to: '/be/teksten?pagina=journal' },
  { text: 'Algemene voorwaarden en privacy laten nakijken', to: null },
  { text: 'Eigen behandelfoto voor het donkere beeldblok op de homepage', to: null },
]
